import { render, staticRenderFns } from "./LeaveTeamModal.vue?vue&type=template&id=5a8fbbbc&scoped=true&"
import script from "./LeaveTeamModal.vue?vue&type=script&lang=js&"
export * from "./LeaveTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fbbbc",
  null
  
)

export default component.exports